const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(":host{display:inline}:host([hidden]){display:none}");
export default styleSheet;